import { useRef, useState } from "react";
import CasesApi from "../../api/cases/index.js";
import { usePermissions } from "../../hooks/usePermissions";
import DropdownMenu from "../../Monolith-UI/DropdownMenu/DropdownMenu.js";
import CasePriorities from "./CasePriorities";
import { Case } from "@/pages/Cases/types/Cases";

interface Priority {
  priority_id: number;
  priority_name: string;
  color: string;
  icon: React.ElementType;
}

const PrioritySelector = ({
  rowData,
  onChange = () => {},
}: {
  rowData: Case;
  onChange: (data: unknown) => void;
}) => {
  const { hasPermission } = usePermissions();
  const [current, setCurrent] = useState(
    CasePriorities?.find((p: Priority) => p.priority_id === rowData.priority_id)
      ?.priority_name
  );
  const containerRef = useRef<HTMLDivElement>(null);

  const currentPriority: Priority | undefined = CasePriorities?.find(
    (p: Priority) => p.priority_name === current
  );

  const handleItemSelect = async (item: Priority) => {
    setCurrent(item.priority_name);
    containerRef?.current?.classList.remove("custom-action-button");
    await CasesApi.updateCase(rowData.case_id, {
      priority_id: item.priority_id,
    });

    onChange({
      priority_id: item.priority_id,
    });
  };

  const menuItems = [
    {
      radioGroup: true,
      value: currentPriority?.priority_id,
      onSelectionChanged: (data: { value: number; label: string }) => {
        const priority = CasePriorities.find(
          (p: Priority) => p.priority_id === data.value
        );
        if (priority) {
          handleItemSelect(priority);
        }
      },
      items: CasePriorities.map((p: Priority) => ({
        label: p.priority_name,
        value: p.priority_id,
        icon: p.icon,
        iconColor: p.color,
      })),
    },
  ];

  return (
    <div
      ref={containerRef}
      className={`${currentPriority ? "" : "action-button"}`}
    >
      <DropdownMenu
        defaultValue={undefined}
        dropdownContent={undefined}
        menuItems={menuItems}
        disabled={!hasPermission()}
        title={"Select Priority"}
        variant={"contained"}
        textColor={current ? "primary" : "secondary"}
        buttonProps={{
          style: {
            fontSize: 12,
          },
        }}
      >
        {currentPriority?.icon && (
          <currentPriority.icon
            color={currentPriority.color}
            size={13}
            style={{ marginRight: 5 }}
          />
        )}
        {current ? <div>{current}</div> : <div>Select...</div>}
      </DropdownMenu>
    </div>
  );
};

export default PrioritySelector;
